/* eslint-env browser */

import { Controller } from '@hotwired/stimulus'
import { randomString } from '../../../../utils/random'
import { post } from '@rails/request.js'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  static values = {
    url: String
  }

  connect () {
    this.verifyDeviceAndRedirect()
  }

  async verifyDeviceAndRedirect () {
    const body = { authorization: { device_id: this.#deviceId } }

    try {
      const result = await post(this.urlValue, {
        body: JSON.stringify(body),
        responseKind: 'turbo-stream'
      })

      if (result.redirected) {
        this.#redirectTo(result.response.url)
      }
    } catch (error) {
      console.error('Failed to verify device:', error)
    }
  }

  #redirectTo (url) {
    try {
      const redirectUrl = new URL(url, document.baseURI)
      Turbo.visit(redirectUrl)
    } catch (error) {
      console.error('Invalid redirect URL:', error)
    }
  }

  get #deviceId () {
    return localStorage.getItem('deviceId') || randomString()
  }
}
